// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.OnlinePortal_additionalTitle__1A7zn > a,\n.OnlinePortal_additionalTitle__1A7zn > span {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  color: #1890ff; }\n\n.OnlinePortal_additionalTitle__1A7zn .ant-row.ant-form-item {\n  font-weight: normal;\n  width: 200px;\n  margin-bottom: 0; }\n\n.OnlinePortal_wrapper__2_tU7 > div:first-child {\n  padding-bottom: 12px !important; }\n  .OnlinePortal_wrapper__2_tU7 > div:first-child > span {\n    align-self: flex-end; }\n", ""]);
// Exports
exports.locals = {
	"additionalTitle": "OnlinePortal_additionalTitle__1A7zn",
	"wrapper": "OnlinePortal_wrapper__2_tU7"
};
module.exports = exports;
